import { useState, useMemo, useEffect } from "react";
// Path changed back to 1 level up, because stlViewerSession.js is now in caseTable/
import { loadViewerState } from "../stlViewerSession"; 
import { OPACITY_MAX, DEFAULT_MODEL_STATE, CLIP_PLANE_SIZE_MULT_DEFAULT } from "../constants";

export const useViewerState = ({ isSmall, isMulti, fileUrl, fileUrls }) => {
  const persisted = useMemo(
    () => (isSmall ? null : loadViewerState(isMulti ? fileUrls[0]?.url : fileUrl)),
    [fileUrl, fileUrls, isSmall, isMulti]
  );

  const [wireframe, setWireframe] = useState(() => !!persisted?.wireframe);
  const [autoRotate, setAutoRotate] = useState(() => !!persisted?.autoRotate);
  const [opacity, setOpacity] = useState(() =>
    typeof persisted?.opacity === "number" ? persisted.opacity : OPACITY_MAX
  );
  const [showOpacity, setShowOpacity] = useState(() =>
    typeof persisted?.showOpacity === "boolean" ? persisted.showOpacity : true
  );
  const [expanded, setExpanded] = useState(() => !!persisted?.expanded);
  const [ready, setReady] = useState(false);
  const [sidebarHidden, setSidebarHidden] = useState(false);

  const [showCrossSection, setShowCrossSection] = useState(() => !!persisted?.showCrossSection);
  const [clipEnabled, setClipEnabled] = useState(() => !!persisted?.clipEnabled);
  const [clipInverted, setClipInverted] = useState(() => !!persisted?.clipInverted);
  const [planeOffset, setPlaneOffset] = useState(() =>
    typeof persisted?.planeOffset === "number" ? persisted.planeOffset : 0
  );
  const [crossSectionOutline, setCrossSectionOutline] = useState(null);
  const [planeSizeMult, setPlaneSizeMult] = useState(() =>
    typeof persisted?.planeSizeMult === "number"
      ? persisted.planeSizeMult
      : CLIP_PLANE_SIZE_MULT_DEFAULT
  );
  const [measureMode, setMeasureMode] = useState(() => !!persisted?.measureMode);
  const [sectionDrawMode, setSectionDrawMode] = useState(false);
  const [xsMeasureVersion, setXsMeasureVersion] = useState(0);

  const [modelStates, setModelStates] = useState({});
  const [filesPanelOpen, setFilesPanelOpen] = useState(true);

  const fileKey = isMulti
    ? fileUrls.map((f) => (f && f.url) || f).join("|")
    : "";

  useEffect(() => {
    setModelStates({});
  }, [fileKey]);

  const getModelState = (i) => modelStates[i] || DEFAULT_MODEL_STATE;
  const updateModelState = (i, patch) =>
    setModelStates((prev) => ({
      ...prev,
      [i]: { ...DEFAULT_MODEL_STATE, ...(prev[i] || {}), ...patch },
    }));

  return {
    persisted,
    wireframe, setWireframe,
    autoRotate, setAutoRotate,
    opacity, setOpacity,
    showOpacity, setShowOpacity,
    expanded, setExpanded,
    ready, setReady,
    sidebarHidden, setSidebarHidden,
    showCrossSection, setShowCrossSection,
    clipEnabled, setClipEnabled,
    clipInverted, setClipInverted,
    planeOffset, setPlaneOffset,
    crossSectionOutline, setCrossSectionOutline,
    planeSizeMult, setPlaneSizeMult,
    measureMode, setMeasureMode,
    sectionDrawMode, setSectionDrawMode,
    xsMeasureVersion, setXsMeasureVersion,
    modelStates, setModelStates,
    filesPanelOpen, setFilesPanelOpen,
    getModelState, updateModelState,
  };
};